import React from 'react';
import { styled } from '@mui/material/styles';
import logo from 'src/assets/images/trakgeneLogo.png';

const PaperContainer = styled('div')(({ theme }) => ({
  marginTop: theme.spacing(3),
  marginBottom: theme.spacing(4),
  marginLeft: 'auto',
  marginRight: 'auto',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  borderRadius: 8,
  border: '1px solid #dadce0',
  padding: '30px 50px 20px 50px',
  width: '35%',
  [theme.breakpoints.down('lg')]: {
    width: '45%'
  },
  [theme.breakpoints.down('md')]: {
    width: '100%'
  }
}));

const Content = styled('div')(({ theme }) => ({
  width: '100%',
  marginTop: theme.spacing(4)
}));

const Logo = styled('img')({
  width: '300px'
});

// logoUrl semantics:
//   undefined → branding not yet resolved; render no logo to avoid a flash of
//               the wrong image before we know which one to show
//   null      → branding resolved, no custom logo set; render the bundled default
//   string    → render the custom logo
export default function BoxContainer({ children, logoUrl }) {
  return (
    <PaperContainer>
      {logoUrl !== undefined && <Logo src={logoUrl || logo} alt="Logo" />}
      <Content>{children}</Content>
    </PaperContainer>
  );
}
